import { useState, useEffect } from 'react';

/** Fetches `/api/rt/plans` for landing + pricing page (sorted by price). */
export function useMarketingPlans() {
  const [apiPlans, setApiPlans] = useState(null);

  useEffect(() => {
    fetch('/api/rt/plans')
      .then((r) => r.json())
      .then((d) => {
        if (d?.success && Array.isArray(d.data) && d.data.length > 0) {
          setApiPlans([...d.data].sort((a, b) => Number(a.price) - Number(b.price)));
        }
      })
      .catch(() => {});
  }, []);

  return apiPlans;
}
